/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Oto_B2_DescInputs */

const en_simple_oto_b2_desc = /** @type {(inputs: Simple_Oto_B2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each step is done one at a time and proven to pass before it counts. You watch the progress, not the jargon.`)
};

const id_simple_oto_b2_desc = /** @type {(inputs: Simple_Oto_B2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap langkah dikerjakan satu per satu dan dibuktikan lulus sebelum dihitung. Kamu melihat kemajuannya, bukan istilahnya.`)
};

/**
* | output |
* | --- |
* | "Each step is done one at a time and proven to pass before it counts. You watch the progress, not the jargon." |
*
* @param {Simple_Oto_B2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_oto_b2_desc = /** @type {((inputs?: Simple_Oto_B2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Oto_B2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_oto_b2_desc(inputs)
	return en_simple_oto_b2_desc(inputs)
});